module.exports = __webpack_public_path__ + "static/media/Bedroom6-2.9c6b0f1f.jpg";